import { SpinnerCircle } from "./SpinnerCircle.styles";

interface SpinnerProps {
    size?: number;
}

function Spinner({ size = 15 }: SpinnerProps) {
    return <SpinnerCircle size={size} />;
}

export default Spinner;
